<template>
  <div>
    <div class="rider-info pad_20">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('store.detail.title') }}</span>
        </div>
      </div>
      <div class="header-info pad_10 flex">
        <div class="flex">
          <div class="head-pic flex">
            <img src="~@/assets/img/moren.png" alt srcset />
            <div class="mar_l20">
              <h4>{{ storeName }}</h4>
              <span>ID：{{ formData.id }}</span>
            </div>
          </div>
        </div>
        <div class="flex mar_l50">
          <div class="mar_l50">
            <h4>{{ $t('store.detail.balance') }}</h4>
            <span class="color_b fon_16 wei">{{ formData.money }}</span>
          </div>
          <div class="mar_l40">
            <h4>{{ $t('store.detail.points') }}</h4>
            <span class="color_b fon_16 wei">{{ 0 }}</span>
          </div>
        </div>
        <div class="headState">
          <div class="color_b wei fon_16">{{ $t('store.detail.linkedShop') }}</div>
          <span>{{ $t('store.detail.bindChannel') }}</span>
        </div>
      </div>
      <div class="pad_20">
        <el-form ref="form" :model="formData" label-width="100px">
          <el-form-item :label="$t('store.detail.storeName')" :required="true" prop="storeName">
            <el-input v-model="formData.storeName" :placeholder="$t('store.detail.storeNamePh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('store.detail.regTime')">{{ $moment(formData.createdAt*1000).format('YYYY-MM-DD HH:mm:ss') }}</el-form-item>
          <el-form-item :label="$t('store.detail.merchantNo')">{{ formData.appId }}</el-form-item>
          <el-form-item label="AppKey">{{ formData.appKey }}</el-form-item>
          <el-form-item label="AppSecret">{{ formData.appSecret }}</el-form-item>
          <el-form-item :label="$t('store.detail.contact')" :required="true" prop="userName">
            <el-input v-model.trim="formData.userName" :placeholder="$t('store.detail.contactPh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('store.detail.tel')" :required="true" prop="tel">
            <el-input v-model.trim="formData.tel" :placeholder="$t('store.detail.telPh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('store.detail.license')" :required="true" prop="media">
            <custom-upload v-model="formData.media"></custom-upload>
          </el-form-item>
          <el-form-item :label="$t('store.detail.address')" :required="true" prop="address">
            <el-input v-model.trim="formData.address" :placeholder="$t('store.detail.addressPh')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('store.detail.orderStats') }}</span>
        </div>
      </div>
      <div class="flex pad_10 flex-bet">
        <div class="footer-ls">
          <h4>{{ $t('store.detail.totalOrders') }}</h4>
          <span class="color_b">{{ formData.orderNum }}</span>
        </div>
        <div class="footer-ls">
          <h4>{{ $t('store.detail.totalDeliveryFee') }}</h4>
          <span class="color_b">{{ formData.deliveryMoney }}</span>
        </div>
        <div class="footer-ls">
          <h4>{{ $t('store.detail.totalRecharge') }}</h4>
          <span class="color_b">{{ formData.chargeMoney }}</span>
        </div>
        <div class="footer-ls">
          <h4>{{ $t('store.detail.cancelComplaint') }}</h4>
          <span class="color_b">0</span>
        </div>
      </div>
    </div>
    <div class="footer-btn flex-center mar_t20 pad_20 bg-0">
      <el-button type="primary" @click="save">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getStoreInfo, addStore } from '@/api/store';
import customUpload from '@/components/custom-upload.vue';
import Selectmap from '../../plugins/selectmap.vue';
export default {
  components: { customUpload, Selectmap },
  data() {
    return {
      levelList: [],
      formData: {
        id: '',
        storeName: '',
        userName: '',
        tel: '',
        type: '',
        media: '',
        address: '',
        lng: '',
        lat: ''
      },
      storeName: ''
    };
  },
  mounted() {
    const id = this.$route.query.id;
    this.getStoreInfo(id);
  },
  methods: {
    upSuccess(key, res) {
      this.formData[key] = res;
    },
    getStoreInfo(id) {
      getStoreInfo({ id: id }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.formData, res.data);
          this.storeName = this.formData.storeName;
        }
      });
    },
    getMapdata(mapAddress, mapLat, mapLng) {
      this.formData.address = mapAddress;
      this.formData.lat = mapLat;
      this.formData.lng = mapLng;
    },
    searchMapClick() {},
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { msg } = await addStore(this.formData);
          this.$baseMessage(msg, 'success');
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.rider-info {
  background: #ffffff;

  .header-info {
    position: relative;
    background: #F0FAFF;

    .head-pic {
      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
      }
    }

    .headState {
      position: absolute;
      right: 60px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .footer-ls {
    h4 {
      font-size: 14px;
    }

    span {
      font-size: 12px;
    }
  }
}

.footer-btn {
  background: #ffffff;
}
</style>
